<div class="modal-header">
	<h4 class="modal-title">Offline bereitstellen</h4>
</div>
<div class="modal-body">
	<!-- Alles bereit - wenn beide Downloads übersprungen werden -->
	@if (skipTileDownload && skipPointsDownload) {
		<div class="text-center py-3">
			<i class="bi bi-check-circle-fill text-success fs-1 mb-3 d-block"></i>
			<p class="mb-0">Alle Daten sind bereits für Offline-Nutzung verfügbar.</p>
		</div>
	}

	<!-- Karten-Tiles (nur anzeigen wenn Tiles heruntergeladen werden) -->
	@if (!skipTileDownload) {
		<div class="mb-3">
			<h6 class="fw-bold mb-2">
				<i class="bi bi-map me-2"></i>Kartenkacheln
			</h6>
			@if (tileItems().length === 0) {
				@if (startupTimedOut()) {
					<div class="alert alert-warning small mb-0">
						<i class="bi bi-exclamation-triangle me-2"></i>
						Der Download konnte nicht gestartet werden. Bitte warten Sie, bis die Kartenlayer vollständig geladen sind, und versuchen Sie es erneut.
					</div>
				} @else {
					<div class="text-muted small">
						<span class="spinner-border spinner-border-sm me-2" role="status"></span>
						Warte auf Start...
					</div>
				}
			}
			@for (item of tileItems(); track $index) {
				<div class="mb-2">
					<div class="d-flex justify-content-between align-items-center mb-1">
						<span>
							<i class="bi me-2" [class]="getStatusIcon(item.status)"></i>
							{{ item.name }}
						</span>
						<small class="text-muted">
							@if (item.sizeBytes) {
								{{ formatBytes(item.sizeBytes) }}
							}
							@if (item.status === 'pending') {
								Warte...
							}
							@if (item.status === 'downloading') {
								{{ item.progress }} / {{ item.max }}
							}
							@if (item.status === 'done') {
								Fertig
							}
						</small>
					</div>
					<ngb-progressbar
						[type]="item.status === 'done' ? 'success' : (item.status === 'pending' ? 'secondary' : 'primary')"
						[value]="item.status === 'pending' ? 0 : item.progress"
						[max]="item.max"
						[striped]="item.status === 'downloading' || item.status === 'pending'"
						[animated]="item.status === 'downloading'">
					</ngb-progressbar>
				</div>
			}
		</div>
	}

	<!-- Datenpunkte (nur anzeigen wenn Punkte heruntergeladen werden) -->
	@if (!skipPointsDownload) {
		@if (!skipTileDownload) {
			<hr>
		}
		<div class="mb-3">
			<h6 class="fw-bold mb-2">
				<i class="bi bi-geo-alt me-2"></i>{{ pointsLabel }}
				@if (expectedPointsCount > 0) {
					<small class="text-muted fw-normal">({{ expectedPointsCount }} Punkte)</small>
				}
			</h6>
			<div class="mb-2">
				<div class="d-flex justify-content-between align-items-center mb-1">
					<span>
						<i class="bi me-2" [class]="getStatusIcon(pointsStatus())"></i>
						Punktdaten
					</span>
					<small class="text-muted">
						@if (pointsStatus() === 'downloading') {
							{{ dataProvider.loadingProgressText || 'Lade...' }}
						}
						@if (pointsStatus() === 'done') {
							{{ loadedPointsCount() || expectedPointsCount }} Punkte geladen
						}
					</small>
				</div>
				<ngb-progressbar
					[type]="pointsStatus() === 'done' ? 'success' : 'primary'"
					[value]="pointsProgress()"
					[striped]="pointsStatus() === 'downloading'"
					[animated]="pointsStatus() === 'downloading'">
				</ngb-progressbar>
			</div>
		</div>
	}
</div>
<div class="modal-footer">
	@if (isDownloading) {
		<button type="button" class="btn btn-outline-danger"
				(click)="onCancel()">
			<i class="bi bi-x-circle me-1"></i>
			Abbrechen
		</button>
	}
	<button type="button" class="btn btn-primary"
			[disabled]="isDownloading"
			(click)="onClose()">
		@if (isDownloading) {
			<span class="spinner-border spinner-border-sm me-2" role="status"></span>
			Wird heruntergeladen...
		} @else if (wasCancelled) {
			Abgebrochen - Schließen
		} @else {
			Schließen
		}
	</button>
</div>
